import { useState } from 'react';

interface UsePaginationProps {
  initialPage?: number;
  initialPageSize?: number;
}

interface PaginationState {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
}

export const usePagination = ({ 
  initialPage = 1, 
  initialPageSize = 10 
}: UsePaginationProps = {}) => {
  const [pagination, setPagination] = useState<PaginationState>({
    currentPage: initialPage,
    pageSize: initialPageSize,
    totalPages: 0,
    totalItems: 0,
  });

  const setPage = (page: number) => {
    setPagination(prev => ({ ...prev, currentPage: page }));
  };

  const setPageSize = (size: number) => {
    setPagination(prev => ({ 
      ...prev, 
      pageSize: size,
      currentPage: 1 // Reset to first page when changing page size
    }));
  };

  const setTotalItems = (total: number) => {
    const totalPages = Math.ceil(total / pagination.pageSize);
    setPagination(prev => ({ 
      ...prev, 
      totalItems: total,
      totalPages
    }));
  };

  return {
    ...pagination,
    setPage,
    setPageSize,
    setTotalItems,
  };
};